(function () {
  'use strict';
  const trigger = document.getElementById('tf-menu-open');
  const drawer = document.getElementById('tf-menu-drawer');
  const closeButton = document.getElementById('tf-menu-close');
  const shell = document.getElementById('tf-site-shell');
  let savedPageState = null;
  let closeTimer = null;
  let pointerStartedOutside = false;
  function updateGeometry() {
    const bounds = shell.getBoundingClientRect();
    drawer.style.setProperty('--tf-menu-left', bounds.left + 'px');
    drawer.style.setProperty('--tf-menu-width', bounds.width * 0.75 + 'px');
  }
  trigger.addEventListener('click', () => {
    if (drawer.open) return;
    updateGeometry();
    drawer.removeAttribute('data-closing');
    savedPageState = { x: window.scrollX, y: window.scrollY, body: document.body.style.cssText, overflow: document.documentElement.style.overflow };
    drawer.showModal();
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = -savedPageState.y + 'px';
    document.body.style.left = -savedPageState.x + 'px';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    drawer.querySelector('.tf-menu-content').scrollTop = 0;
    trigger.setAttribute('aria-expanded', 'true');
  });
  function close() {
    if (!drawer.open || drawer.hasAttribute('data-closing')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      drawer.close();
      return;
    }
    drawer.setAttribute('data-closing', '');
    closeTimer = window.setTimeout(() => drawer.close(), 240);
  }
  closeButton.addEventListener('click', close);
  drawer.addEventListener('cancel', event => { event.preventDefault(); close(); });
  function outside(event) {
    const bounds = drawer.getBoundingClientRect();
    return event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
  }
  drawer.addEventListener('pointerdown', event => { pointerStartedOutside = event.target === drawer && outside(event); });
  drawer.addEventListener('pointercancel', () => { pointerStartedOutside = false; });
  drawer.addEventListener('click', event => {
    if (pointerStartedOutside && event.target === drawer && outside(event)) close();
    pointerStartedOutside = false;
  });
  drawer.addEventListener('close', () => {
    window.clearTimeout(closeTimer);
    closeTimer = null;
    drawer.removeAttribute('data-closing');
    if (savedPageState) {
      document.body.style.cssText = savedPageState.body;
      document.documentElement.style.overflow = savedPageState.overflow;
      window.scrollTo(savedPageState.x, savedPageState.y);
      savedPageState = null;
    }
    pointerStartedOutside = false;
    trigger.setAttribute('aria-expanded', 'false');
    trigger.focus({ preventScroll: true });
  });
  window.addEventListener('resize', () => { if (drawer.open) updateGeometry(); }, { passive: true });
})();
